<div class="panneau-tester-lecteur__container">
	<div class="container__content">
		<div class="button-menu">
			<lua-bouton-icone iconName="more_vert" size="medium" (click)="openMenu($event)"></lua-bouton-icone>
		</div>
		<h4>Logs SCE :</h4>
		<div class="sce-log-panel">
      <div class="sce-log-message" *ngFor="let log of sceLogs">
				<span>- {{ log }}</span>
			</div>
    </div>
		<ng-container *ngIf="demandeCodeCPS">
			<lua-input [fullWidth]="true" type="password" [(ngModel)]="cpsSaisie" placeholder="Code" label="Vous devez saisir le code CPS de la carte" (input)="validateCpsSaisie()"></lua-input>
			<lua-alerte *ngIf="errorCodeShow" type="warning" [message]="errorCodeMessage"></lua-alerte>
			<lua-action-secondaire [isDisabled]="!cpsSaisie" libelle="C'est fait !"
				(click)="sendCodeCPS()"></lua-action-secondaire>
		</ng-container>
</div>
